var _winWid = ""
  , _winHgt = ""
  , _portrait = "true"
  , _trans = true
  , _ie = false;
winSize();
function winSize() {
    _winWid = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
    _winHgt = document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
    if (_winWid / _winHgt > 1) {
        _portrait = false
    } else {
        _portrait = true
    }
}
function boutiqueRoll(B) {
    var c = $(B)
      , a = c.find(".list-boutique-roll li")
      , u = c.find(".list-boutique-indicator")
      , w = c.find(" .box-boutique-indicator button")
      , f = a.length
      , e = 0
      , A = 5000
      , o = false
      , k = null;
    var r = 0
      , t = 0
      , i = 0
      , h = 0
      , n = 0
      , v = 0
      , z = 10
      , l = 0
      , j = false;
    $(window).resize(function() {
        winSize();
        s()
    });
    x();
    s();
    function q() {
        var D = $(".visual-boutique")
          , C = 155;
        if (_winWid < 765) {
            D.removeAttr("style")
        } else {
            D.css({
                height: _winHgt - 155 + "px"
            })
        }
    }
    function x() {
        if (f == 1) {
            $(".box-boutique-indicator").css({
                display: "none"
            })
        } else {
            u.find(".first").remove();
            c.find(".btn-boutique-start").addClass("off");
            for (var C = 0; C < f; C++) {
                u.append('<li><a href="#">' + C + "</a></li>")
            }
            u.find("li").eq(0).addClass("on");
            g()
        }
    }
    function s() {
        for (var E = 0; E < f; E++) {
            var F = a.eq(E).find("img").attr("src")
              , D = F.replace(/^.*\//, "")
              , C = F.match(/^.*\//);
            C = C[C.length - 1];
            if (_winWid > 765) {
                a.find(".slide").eq(E).css({
                    "background-image": "url(" + F + ")"
                })
            } else {
                a.find(".slide").eq(E).css({
                    "background-image": "url(" + C + "m_" + D + ")"
                })
            }
        }
        if (_winWid > 765 || $(".box-cur").length || f == 1) {
            return
        }
        c.after('<p class="box-cur"><span class="txt-cur">' + (l + 1) + '</span> of <span class="txt-all">' + f + "</span></p>")
    }
    w.on("click", function() {
        var D = $(this)
          , C = D.parent().attr("class");
        w.parent().addClass("off");
        if (C.indexOf("start") != -1) {
            c.find(".btn-boutique-pause").removeClass("off");
            g()
        } else {
            c.find(".btn-boutique-start").removeClass("off");
            b()
        }
        return false
    });
    $(document).on("mouseenter mouseleave click", ".list-boutique-indicator li a", function(D) {
        var C = $(this).parent().index();
        if (D.type == "mouseenter") {
            b()
        } else {
            if (D.type == "mouseleave") {
                g()
            } else {
                if (D.type == "click") {
                    y(C)
                }
            }
        }
        return false
    });
    function b() {
        clearInterval(k);
        k = null
    }
    function g() {
        if (k != null) {
            return
        }
        k = setInterval(function() {
            l++;
            y()
        }, A)
    }
    function y(C) {
        if (o) {
            return
        }
        if (C != undefined) {
            l = C
        }
        if (l > f - 1) {
            l = 0
        } else {
            if (l < 0) {
                l = f - 1
            }
        }
        a.eq(e).fadeOut();
        u.find(" li ").eq(e).removeClass("on");
        u.find(" li ").eq(l).addClass("on");
        $(".box-cur .txt-cur").text(l + 1);
        a.eq(l).addClass("ready").fadeIn(function() {
            $(this).removeClass("ready").addClass("on");
            g();
            e = l;
            o = false;
            j = false
        })
    }
    if (_winWid < 765 && f > 1) {
        c.off("touchstart touchmove touchend");
        c.on("touchstart", m);
        c.on("touchend", d);
        c.on("touchmove", p)
    }
    function m(D) {
        var C = D.originalEvent;
        _firstY = C.touches[0].screenY;
        _firstX = C.touches[0].screenX;
        i = 0;
        h = 0;
        j = true
    }
    function p(D) {
        if (!j) {
            return
        }
        v = $(window).scrollTop();
        var C = D.originalEvent;
        i = _firstY - C.touches[0].screenY;
        h = _firstX - C.touches[0].screenX;
        if (j && Math.abs(h) > Math.abs(i)) {
            D.preventDefault()
        }
    }
    function d(C) {
        v = $(window).scrollTop();
        if (!j || Math.abs(h) < Math.abs(i) || Math.abs(h) < 70) {
            j = false;
            return
        }
        if (h < 0) {
            l--
        } else {
            l++
        }
        b();
        y()
    }
}
function boutiqueLocation() {
    if (!$(".area-boutique-location").length) {
        return
    }
    var b = $(".area-boutique-location")
      , a = b.find(".list-boutique-location li")
      , c = a.find(" > a");
    c.on("click", function() {
        var d = $(this);
        if (!d.parent().hasClass("on")) {
            a.removeClass("on");
            d.parent().addClass("on")
        } else {
            d.parent().removeClass("on")
        }
        return false
    })
}
$(document).ready(function() {
    if ($(".visual-boutique").length) {
        boutiqueRoll(".visual-boutique")
    }
    if ($(".visual-boutique-event").length) {
        boutiqueRoll(".visual-boutique-event")
    }
});
